/**
 * The longest gap between two keystrokes a scanner leaves. A person cannot type this fast, so
 * anything quicker is a scanner.
 *
 * `useBarcodeScanner` detects a scan by it, and `useScannerEnterGuard` uses it to tell a scanner's
 * trailing Enter from a person's.
 */
const SCANNER_INTER_CHAR_DELAY_MS = 50

/**
 * How long the buffer waits after the last keystroke before it flushes a scan with no Enter. Until then, an
 * Enter ends the scan, however long after the last character it comes.
 */
const SCANNER_INACTIVITY_TIMEOUT_MS = 150

export { SCANNER_INACTIVITY_TIMEOUT_MS, SCANNER_INTER_CHAR_DELAY_MS }
